<template>
  <div class="vote-tip">
    {{ tipText }}
    <!-- <div>*选项顺序为系统自动排序</div> -->
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    isEnded: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      voteText: ''
    }
  },
  components: {
  },
  watch: {},
  computed: {
    tipText() {
      if (this.data.type == 1 && !this.isEnded) return `*单选，点击选项下方按钮即可${this.voteText}`;
      if (this.data.type == 2 && !this.isEnded) {
        if (this.data.vote_min == this.data.vote_max) {
          return `*多选，需选择${this.data.vote_min}项`;
        } else {
          return `*多选，选择不得少于${this.data.vote_min}项，不得多于${this.data.vote_max}项`;
        }
      }
      if (this.isEnded) return `*活动现已结束`;
    }
  },
  methods: {
  },
  created() {
    this.voteText = this.$store.state.voteText;
  },
}
</script>

<style scoped lang="less">
.vote-tip {
  font-size: 0.28rem;
  color: #999;
  text-align: center;
  margin: 0.2rem 0;
}
</style>